import React from "react";
import { Card, Row } from "antd";
import moment from "moment-jalaali";
import { STATIC_MAP_URL } from "../../constants";
import { format } from 'react-string-format'
import './style.css'
import Currency from "components/Currency";


export default function TripCard(props) {
    const { onClick, trip } = props;
    let createTripTitle = (startTime) => {
        const tripStartTime = moment(startTime);
        return tripStartTime.format('jYYYY/jM/jD')
    }
    let createTripStartHour = (startTime) => {
        const tripStartTime = moment(startTime);
        return tripStartTime.format('HH:mm')
    }
    const rideMapImg = format(STATIC_MAP_URL, trip.startLocation.lat, trip.startLocation.lon)
    const durationMnts = Math.ceil(trip.duration / 60)
    return <Card
        className='trip-history-card mb-1'
        onClick={onClick}
        cover={
            <img
                alt="ride-map"
                src={rideMapImg}
            />
        }
    >
        <Row className='trip-history-card-first-row'>
            <p className='f-22 mb-0'>
                {createTripTitle(trip.startTime)}
            </p>
            <p className='mr-auto f-16 mb-0'>
                {durationMnts}
                &nbsp;
                دقیقه
            </p>
        </Row>
        <Row className='trip-history-card-second-row'>
            <p className='f-14 mb-0'>
                {createTripStartHour(trip.startTime)}
            </p>
            <p className='mr-auto f-14 mb-0'>
                <Currency value={(trip.totalPrice)} />
            </p>
        </Row>

    </Card>
}